var _circle, _rect, _path, _rect2, _path2, _rect3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#201E26"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 9,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#A1A3B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.875L8.87554 11.7779C8.9934 11.8994 9.18842 11.8994 9.30628 11.7779L12 9",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 23,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#A1A3B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 24.875L8.87554 25.7779C8.9934 25.8994 9.18842 25.8994 9.30628 25.7779L12 23",
    stroke: "white",
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 16,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#A1A3B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.09088 19L11 16M8 16L11 19",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test_icon.95a406a11bf47f22d9ed0d76ad9376b8.svg";
export { ForwardRef as ReactComponent };